import { action, noop } from '@reatom/framework'

import type { PairAddress } from '../model/PairAddress'
import type { Network } from '@root/entities/network'

export const pairFocusEvent = action<
  [{ network: Network.Network; address: PairAddress }]
>(noop, 'pairFocusEvent')

export * from './pair-registry'
export * from './prefetch-url-pair'
export * from './pair-requests'
export * from './reatom-pair-reused-short'
export * from './reatom-pair'
export * from './reatom-pair-info-bulk'
export { type PriceChartInterval } from './reatom-pair-price-chart'
export * from './reatom-pair-resource'
